export default __webpack_public_path__ + "static/media/V730_RoHS.1477cb57.pdf";